export default function EmailCampaigns() {
  return <div style={{ padding: 32 }}>Email Campaigns coming soon</div>
}